import React from "react";

export const FEEDBACK_EMAIL = "feedback@appspacesolutions.in";

export function openEmailClient(email) {
  const link = document.createElement("a");
  link.href = `mailto:${email}`;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default function EmailLink({
  email = FEEDBACK_EMAIL,
  className = "text-blue-600 underline hover:text-blue-800 cursor-pointer",
  children,
}) {
  const handleClick = (e) => {
    e.preventDefault();
    openEmailClient(email);
  };

  return (
    <a href={`mailto:${email}`} onClick={handleClick} className={className}>
      {children ?? email}
    </a>
  );
}
